// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BoardController from "./board_controller"
application.register("board", BoardController)

import ClipboardurlController from "./clipboardurl_controller"
application.register("clipboardurl", ClipboardurlController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import StatsController from "./stats_controller"
application.register("stats", StatsController)
